import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rangeY'
})
export class RangeYPipe implements PipeTransform {
  transform(yValues: number[] | null | undefined, threshold: number = 0): [number, number] {
    const t = Number(threshold) || 0;
    const lowerThreshold = t === 0 ? 0 : -t;

    if (!Array.isArray(yValues) || yValues.length === 0) {
      return [lowerThreshold, t];
    }

    const nums = yValues
      .filter(v => v != null)
      .map(v => Number(v))
      .filter(n => Number.isFinite(n));

    if (nums.length === 0) {
      return [lowerThreshold, t];
    }

    const min = Math.min(...nums);
    const max = Math.max(...nums);
    return [min - t, max + t];
  }
}
